import { Col, Row, Skeleton, Space } from "antd";
import React from "react";

function MineralSkeleton() {
  return (
    // <Row gutter={[16, 16]} style={{ marginTop: "12px", marginLeft: "1rem" }}>
    <>
      <Col md={8}>
        <Skeleton.Input
          active
          style={{
            width: "290px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Skeleton active />
      </Col>
      <Col md={8}>
        <Skeleton.Input
          active
          style={{
            width: "290px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Skeleton active />
      </Col>
      <Col md={8}>
        <Skeleton.Input
          active
          style={{
            width: "290px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Skeleton active />
      </Col>
      <Col md={8}>
        <Skeleton.Input
          active
          style={{
            width: "290px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Skeleton active />
      </Col>
      <Col md={8}>
        <Skeleton.Input
          active
          style={{
            width: "290px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Skeleton active />
      </Col>
      <Col md={8}>
        <Skeleton.Input
          active
          style={{
            width: "290px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
        <Skeleton active />
      </Col>
    </>
    // </Row>
  );
}

export default MineralSkeleton;
